import React from "react";
import "./styles.scss";

const HailPage = () => {
  return (
    <div className="shadow py-2 pb-5 mt-3">
      <div className="HailPage-page"> </div>
    </div>
  );
};

export default HailPage;
{
  /* <div className="p5-page-rule">
<span> Referals Care</span>
<span> 4</span>
</div>
<div className="p5-page-title">
<h3>Easy Way to Earn!</h3>
</div> */
}
